import { Page } from './../utils/pages';

const {
  endsWith
} = require('@maxpreps/shared/functions/server/pageMappingUtils');

export const schedulePageTest = {
  test: url => endsWith(Page.Schedule, url),
  react: '/schedule'
};
